import axios from "axios";

//https://restapi.amap.com/v3/ip?key=fe5f5abdb0a580233374a97ff1bdc679&type=4
//https://restapi.amap.com/v3/geocode/regeo?key=fe5f5abdb0a580233374a97ff1bdc679&location=106.2832832,29.36962828|106.8138242,29.7401968&radius=1000&extensions=all

const locationRequest = axios.create({
  baseURL: "https://restapi.amap.com/v3"
})
export default locationRequest



// WEBPACK FOOTER //
// ./src/utils/LocationUtils.js